import React, { useEffect, useRef, useState } from "react"
import Esign from "../Esign"
import useToggle from "../../../../hooks/toggle"
import { selecteddocumentesign } from "../ReviewDocs"
import { useParams } from "react-router-dom"
import { ALAEarlyocc, getexternaldocuments, getSavedOfferDetails } from "../../../../api/transaction"
import { useSelector } from "react-redux"
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from "@coreui/react"
const ALAearlyoccupancy = ()=>{
  const {id,user} : any = useParams()
  const componentRef = useRef();
const [earlyocc,setEarlyocc] = useState({
  offer_id:id,
  dated :null,
  legal_description :"",
  address :"",
  accupancy_fees :0,
  pay_to_seller :"",
  comments_for_single_family :"",
  pets_may_not :false,
  pets_may_keep :false,
  security_deposit :0,
  dated_this :"",
  day_of :"",
  day_of_ :"",
  seller1_signature :"",
  seller2_signature :"",
  buyer1_signature :"",
  buyer2_signature :"",
  state_of_1 :"",
  county_of_1 :"",
  foregoing_agreement_1 :"",
  seller_name1 :"",
  seller_name2 :"",
  notary_public_1 :"",
  state_of_2 :"",
  county_of_2 :"",
  foregoing_agreement_2 :"",
  buyer_name1 :"",
  buyer_name2 :"",
  notary_public_2 :""


})
const [loader,setloading] = useState(false)
 // @ts-ignore
 const val = useSelector((state)=>state?.new?.signset)
const [canvasmodal, setCanvasModal] = useToggle(false);
const [htmlContent, setHtmlContent] = useState("");
const [offerdetails, setOfferDetails] = useState({});
const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
    offerid : "",
  document_name: "",
  image_base64: "",
  sign_role: 1
  })

  const printf = () => {
    // window.print()
    handlePrint()
};

useEffect(()=>{
  if(val){
    if(user == "seller"){
      setEarlyocc({ ...earlyocc, seller1_signature: val })
    }
    if(user == "client"){
      setEarlyocc({ ...earlyocc, buyer1_signature: val })
    }
  }
  },[val])

const send = async()=>{
  setloading(true)

  if(val){
    if(user === "seller"){
   
      if(earlyocc?.seller1_signature){
        let res = await ALAEarlyocc(earlyocc)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
      }
    }
    else if(user === "client"){
   
      if(earlyocc?.buyer1_signature){
        let res = await ALAEarlyocc(earlyocc)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
      }
    }
  }
  else{
    await ALAEarlyocc(earlyocc)
  }
 
  setloading(false)
}

useEffect(()=>{
  (async function(){
    let offerdetails = await getSavedOfferDetails(id)
    setOfferDetails(offerdetails[0])
    const res =await getexternaldocuments(id,"earlyoccupancy") 
    setEarlyocc({...earlyocc,

      dated :res?.data?.dated,
      legal_description :res?.data?.legal_description,
      address : res?.data?.address,
      accupancy_fees :res?.data?.accupancy_fees,
      pay_to_seller :res?.data?.pay_to_seller,
      comments_for_single_family :res?.data?.comments_for_single_family,
      pets_may_not :res?.data?.pets_may_not,
      pets_may_keep :res?.data?.pets_may_keep,
      security_deposit :res?.data?.security_deposit,
      dated_this :res?.data?.dated_this,
      day_of :res?.data?.day_of,
      day_of_ :res?.data?.day_of_,
      seller1_signature :res?.data?.seller1_signature,
      seller2_signature :res?.data?.seller2_signature,
      buyer1_signature :res?.data?.buyer1_signature,
      buyer2_signature :res?.data?.buyer2_signature,
      state_of_1 :res?.data?.state_of_1,
      county_of_1 :res?.data?.county_of_1,
      foregoing_agreement_1 :res?.data?.foregoing_agreement_1,
      seller_name1 :res?.data?.seller_name1,
      seller_name2 :res?.data?.seller_name2,
      notary_public_1 :res?.data?.notary_public_1,
      state_of_2 :res?.data?.state_of_2,
      county_of_2 :res?.data?.county_of_2,
      foregoing_agreement_2 :res?.data?.foregoing_agreement_2,
      buyer_name1 :res?.data?.buyer_name1,
      buyer_name2 :res?.data?.buyer_name2,
      notary_public_2 :res?.data?.notary_public_2
    })
  })()
},[])

const handlePrint = useReactToPrint({
  content: () => componentRef.current,
});

    return(
        <>
        <>
  <section style={{ pageBreakAfter: "always" }} ref={componentRef}>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 15 }}
    >
      <tbody>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                  <td>
                    <img
                      style={{ width: 30 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                      alt=""
                    />
                    <img
                      style={{ width: 50 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                      alt=""
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span style={{ fontSize: 20, fontWeight: 700 }}>
              Agreement for Purchaser to Occupy Prior to Closing
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              Buyer(s) and Seller(s) have agreed to the sale of the property
              (“Property”) described below under the Purchase Agreement
              (“Purchase Agreement”) dated{" "}
              <input
                type="date"
                value={earlyocc?.dated}
                onChange={(e)=>setEarlyocc({...earlyocc,dated:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />{" "}
              and Buyer(s) will occupy the house and grounds prior to closing of
              the sale. This Agreement shall apply to that occupancy.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span style={{ color: "#3b0083", fontWeight: 600 }}>
              1. THE PROPERTY
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              Legal Description:
              <input
               value={earlyocc?.legal_description}
               onChange={(e)=>setEarlyocc({...earlyocc,legal_description:e.target.value})}
                type="text"
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 900
                }}
              />{" "}
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              The Address is:
              <input
                type="text"//@ts-ignore
                value={offerdetails?.propertyAddress}
                // onChange={(e)=>setEarlyocc({...earlyocc,address:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 920
                }}
              />{" "}
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span style={{ color: "#3b0083", fontWeight: 600 }}>
              2. BUYER(S) DUTIES UNDER THIS AGREEMENT
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>Buyer(s) shall:</span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>a.</span> Pay
              an occupancy fee of $
              <input
                type="number"
                value={earlyocc?.accupancy_fees}//@ts-ignore
                onChange={(e)=>setEarlyocc({...earlyocc,accupancy_fees:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />{" "}
              per day or any part thereof. This occupancy fee shall be collected
              and paid to Seller at the time of occupancy, provided, however,
              that the fee collected on occupancy shall not be more than one
              month’s periodic rent. If the occupancy shall be longer than one
              month, the next month’s rent shall be prepaid for each month, or
              prorated part thereof, on the same day as occupancy for each month
              following occupancy. Any overages or underages to the per diem
              amount shall be adjusted at closing.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>b.</span>{" "}
              From the date occupancy begins, regardless of any provision in the
              Purchase Agreement or this Occupancy Agreement, including any
              contingencies the Buyer may be entitled to for financing, or sale
              of Buyer’s house or any other contingency, should Buyer fail to
              purchase the property under the terms of the Purchase Agreement,
              the Seller shall be entitled to the earnest deposit and the
              earnest deposit shall be forfeited to the Seller and not returned
              to the Buyer.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>c.</span> $
              <input
                type="number"
                value={earlyocc?.pay_to_seller}
                onChange={(e)=>setEarlyocc({...earlyocc,pay_to_seller:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />
              Pay $ to Seller(s) as a security deposit (as opposed to an earnest
              deposit in the Purchase Agreement) against any damage that may
              occur to the property during the occupancy. This shall be a credit
              to Buyer(s) at closing, provided there is no damage to the
              property caused by Buyer(s) beyond ordinary wear and tear and
              provided there is not any unpaid rent. Retention of any part of
              the security deposit shall be in addition to any other rights
              Seller(s) may have with regard to breach of this agreement and
              shall be in addition to any rights the Seller(s) may have for
              breach of the Purchase Agreement which, for the purposes of
              remedy, shall be treated as a separate agreement. This includes
              any rights which Seller(s) may have to specific performance,
              damages and rights under the Purchase Agreement.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>d.</span> The
              premises is as-is.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>e.</span> Pay
              all of the utilities and services during his/her occupancy.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>f.</span>{" "}
              Maintain the house, repair leaks and keep all of its systems and
              appliances in good working order, and Buyer(s) agrees to pay to
              Seller(s) the cost to restore the house to its condition prior to
              Buyer(s)’ occupancy, normal wear and tear excluded.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>g.</span>{" "}
              Maintain the grounds in a neat and tidy fashion.
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <section style={{ pageBreakAfter: "always" }}>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 15 }}
    >
      <tbody>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>h.</span>
              Maintain all personal property in the same condition as it was at
              the beginning of the occupancy, normal wear and tear excepted.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>i.</span>
              Admit Seller(s) or his agent to inspect the property at reasonable
              times.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>j.</span>Keep
              a renter’s policy for property and liability, and indemnify and
              hold harmless Seller(s) from any claims for injury to property or
              persons not covered by insurance. If possible, Buyer(s) shall name
              Seller(s) as a co-insured or a beneficiary on such insurance
              policies. Liability policies shall have a minimum limit of
              $250,000 per occurrence.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>k.</span>Use
              the property only as a single-family residence. People to be
              living in the property shall be:
              <br />
              <textarea
                value={earlyocc?.comments_for_single_family}
                onChange={(e)=>setEarlyocc({...earlyocc,comments_for_single_family:e.target.value})}
                style={{ width: "100%", height: 100, resize: "none" }}
                defaultValue={""}
              />
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>l.</span>Pay
              to Seller(s) any costs of repair to the house and grounds for any
              damage not covered above.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>m.</span>
              Vacate the property within three (3) days following the
              termination of this agreement.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>n.</span>Pay
              costs and attorney fees allowed by law for any action necessary by
              Seller(s) to enforce this agreement.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>o.</span>
              Except for normal maintenance and minor breakdowns, despite any
              language in this agreement to the contrary, Seller(s) shall repair
              and replace any major breakdowns in the electrical systems, air
              systems, plumbing and repair and replace any major structural
              item, except as shall be caused by the neglect, willful misconduct
              or the failure of Buyer(s) to perform the terms of this Agreement.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>Buyer(s) shall not</span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>a.</span>Make
              any changes of any kind to the house or grounds without Seller(s)
              prior written consent, and Buyer(s) agrees to pay to Seller(s) any
              reasonable cost to restore the property to its condition before
              the change.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>b.</span>
              Violate any laws, covenants, rules or regulations applying to the
              property.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>c.</span>Rent
              the property, assign this agreement or sublet the property.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px 10px 30px" }}>
            <span>
              <span style={{ paddingRight: 20, color: "#3b0083" }}>d.</span>Take
              any action that would cause a lien, judgment or encumbrance
              against the property.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              3.
              <span
                style={{ color: "#3b0083", fontWeight: 600, paddingLeft: 10 }}
              >
                {" "}
                RISK OF LOSS.
              </span>
              Any risk of loss to personal property shall be borne by Buyer(s),
              from the date of occupancy to the time of closing. To the extent
              that this modifies the Purchase Agreement, this Agreement
              controls. The parties to this Agreement should consult their
              insurance agent.{" "}
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              4.
              <span
                style={{ color: "#3b0083", fontWeight: 600, paddingLeft: 10 }}
              >
                {" "}
                PETS.{" "}
              </span>
              . Buyer(s)
              <input type="checkbox" checked={earlyocc?.pets_may_not} onChange={()=>setEarlyocc({...earlyocc,pets_may_not:!earlyocc?.pets_may_keep})}/>
              May not 
              <input type="checkbox"  checked={earlyocc?.pets_may_keep} onChange={()=>setEarlyocc({...earlyocc,pets_may_keep:!earlyocc?.pets_may_keep})}/>
              
               May keep domestic pet(s) on the
              property, and a security deposit of $ shall be paid for damage
              that the pet(s) may cause. If neither box is checked, the Buyer(s)
              may not keep pets of any kind. This security deposit shall be paid
              to Seller(s) directly and returned to Buyer(s) should the property
              be returned in as good a condition as received. In the event any
              damage or clean-up is needed beyond ordinary wear and tear, said
              security deposit may be used toward such costs and the balance
              returned to the Buyer(s).{" "}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <section style={{ pageBreakAfter: "always" }}>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 15 }}
    >
      <tbody>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              5.
              <span
                style={{ color: "#3b0083", fontWeight: 600, paddingLeft: 10 }}
              >
                {" "}
                DEFAULT.{" "}
              </span>
              If Buyer(s) fails to do anything required of him under this
              Agreement, Seller(s) may terminate this Agreement. If the Buyer
              does not close in accordance with the purchase agreement,
              Seller(s) may demand that Buyer(s) leave within three (3) days
              (seven (7) days in Iowa) of the written notice personally
              delivered to the property or the Buyer(s) or mailed to the
              property
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              6.
              <span
                style={{ color: "#3b0083", fontWeight: 600, paddingLeft: 10 }}
              >
                {" "}
                CHANGES, WAIVERS.
              </span>
              . No change or modification of this Agreement shall be valid
              unless it is in writing and signed by all parties, No waiver of
              any provision of this Agreement shall be valid unless in writing
              and signed by the person against whom it is sought to be enforced.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              7.
              <span
                style={{ color: "#3b0083", fontWeight: 600, paddingLeft: 10 }}
              >
                {" "}
                TIME IS OF THE ESSENCE.
              </span>
              Time shall be of the essence with regard to every provision of
              this Agreement.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              8.
              <span
                style={{ color: "#3b0083", fontWeight: 600, paddingLeft: 10 }}
              >
                {" "}
                <textarea
                  style={{ width: "90%", height: 300, resize: "none" }}
                  defaultValue={""}
                />{" "}
              </span>
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              THE PARTIES ARE ADVISED TO CONSULT AN ATTORNEY BEFORE SIGNING THIS
              AGREEMENT. THIS AGREEMENT IS PROVIDED BY MILFORD REAL ESTATE
              MERELY AS A CONVENIENCE AND MILFORD REAL ESTATE MAKES NO
              GUARANTEES THAT THIS AGREEMENT WILL BE BENEFICIAL TO EITHER PARTY.
              FURTHER, THE PARTIES ACKNOWLEDGE AND UNDERSTAND THAT MILFORD REAL
              ESTATE’S REPRESENTATION AND DUTIES END AS OF THE CLOSING OF THE
              SALE EXCEPT AS IS SPECIFICALLY PROVIDED BY STATUTE
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span>
              Dated this{" "}
              <input
                type="date"
                value={earlyocc?.dated_this}
                onChange={(e)=>setEarlyocc({...earlyocc,dated_this:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />{" "}
              day of
              <input
                type="text"
                value={earlyocc?.day_of}
                onChange={(e)=>setEarlyocc({...earlyocc,day_of:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 200
                }}
              />{" "}
              ,
              <input
                type="text"
                value={earlyocc?.day_of_}
                onChange={(e)=>setEarlyocc({...earlyocc,day_of_:e.target.value})}
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 100
                }}
              />{" "}
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <span style={{paddingRight: ".5rem"}}>Seller</span>
                    <img
                    src={user=="seller" ? val || (earlyocc?.seller1_signature) : earlyocc?.seller1_signature}
                      id="seller1_signature"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "2px solid #3b0083",
                        width: "100px%"
                      }}
                    />
                    
                  </td>
                  <td>
                  <span style={{paddingRight: ".5rem"}}>Buyer</span>
                    <img
id="buyer1_signature"
src={user=="client" ? (val || earlyocc?.buyer1_signature ): earlyocc?.buyer1_signature}
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "2px solid #3b0083",
                        width: "100px"
                      }}
                    />
                    
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <img
                      id="seller2_signature"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "2px solid #3b0083",
                        width: "90%"
                      }}
                    />
                    <br />
                    Seller
                  </td>
                  <td>
                    <img
                     id="buyer2_signature"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "2px solid #3b0083",
                        width: "90%"
                      }}
                    />
                    <br />
                    Buyer
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <section>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 15 }}
    >
      <tbody>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <table style={{ width: "100%", border: "1px solid #3b0083" }}>
              <tbody>
                <tr>
                  <td>
                    <table
                      style={{
                        borderRight: "1px solid #3b0083",
                        width: "100%",
                        padding: 10
                      }}
                    >
                      <tbody>
                        <tr>
                          <td>
                            <span>
                              STATE OF
                              <input
                                type="text"
                                value={earlyocc?.state_of_1}
                                onChange={(e)=>setEarlyocc({...earlyocc,state_of_1:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              COUNTY OF
                              <input
                                type="text"
                                value={earlyocc?.county_of_1}
                                onChange={(e)=>setEarlyocc({...earlyocc,county_of_1:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              The foregoing Agreement was acknowledged before me
                              on
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              <input
                                type="text"
                                value={earlyocc?.foregoing_agreement_1}
                                onChange={(e)=>setEarlyocc({...earlyocc,foregoing_agreement_1:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 400
                                }}
                              />
                              ,by
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              SELLER’S NAME (PRINTED)
                              <input
                                type="text"
                                value={earlyocc?.seller_name1}
                                onChange={(e)=>setEarlyocc({...earlyocc,seller_name1:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              SELLER’S NAME (PRINTED)
                              <input
                                type="text"
                                value={earlyocc?.seller_name2}
                                onChange={(e)=>setEarlyocc({...earlyocc,seller_name2:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              NOTARY PUBLIC
                              <input
                                type="text"
                                value={earlyocc?.notary_public_1}
                                onChange={(e)=>setEarlyocc({...earlyocc,notary_public_1:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              SEAL:{" "}
                              <textarea
                              
                                style={{
                                  width: "100%",
                                  height: 300,
                                  border: "none",
                                  outline: "none",
                                  resize: "none"
                                }}
                                defaultValue={""}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table style={{ width: "100%", padding: 10 }}>
                      <tbody>
                        <tr>
                          <td>
                            <span>
                              STATE OF
                              <input
                                type="text"
                                value={earlyocc?.state_of_2}
                                onChange={(e)=>setEarlyocc({...earlyocc,state_of_2:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              COUNTY OF
                              <input
                                type="text"
                                value={earlyocc?.county_of_2}
                                onChange={(e)=>setEarlyocc({...earlyocc,county_of_2:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              The foregoing Agreement was acknowledged before me
                              on
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              <input
                                type="text"
                                value={earlyocc?.foregoing_agreement_2}
                                onChange={(e)=>setEarlyocc({...earlyocc,foregoing_agreement_2:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 400
                                }}
                              />
                              ,by
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              SELLER’S NAME (PRINTED)
                              <input
                                type="text"
                                value={earlyocc?.buyer_name1}
                                onChange={(e)=>setEarlyocc({...earlyocc,buyer_name1:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              SELLER’S NAME (PRINTED)
                              <input
                                type="text"
                                value={earlyocc?.buyer_name2}
                                onChange={(e)=>setEarlyocc({...earlyocc,buyer_name2:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              NOTARY PUBLIC
                              <input
                                type="text"
                                value={earlyocc?.notary_public_2}
                                onChange={(e)=>setEarlyocc({...earlyocc,notary_public_2:e.target.value})}
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 300
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              SEAL:{" "}
                              <textarea
                                style={{
                                  width: "100%",
                                  height: 300,
                                  border: "none",
                                  outline: "none",
                                  resize: "none"
                                }}
                                defaultValue={""}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "10px 0px" }}>
            <span>
              NOTE: <br />
              Changes in possession affect insurance rights. Buyer(s) and
              Seller(s) should contact their insurance agents immediately.
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span style={{ color: "#3b0083", fontWeight: 600 }}>
              This is a legally binding contract. If not understood, Buyer(s)
              and Seller(s) may wish to consult an attorney.
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ paddingTop: 600 }}>
            <span>
              Other provisions: Earnest deposit to be delivered within (5)
              business days.
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</>
<React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>
<Esign
        canvasmodal={canvasmodal}
        setCanvasModal={setCanvasModal}
        htmlContent={htmlContent}
        setHtmlContent={setHtmlContent}
        selecteddocumentesign={selecteddocumentesign}
        setselectedDocumentEsign={setselectedDocumentEsign}
        type={"seller"}
      ></Esign>
        </>
    )
}
export default ALAearlyoccupancy